import React from 'react'
import { ClearanceStatusType } from '@modmd/data'
import { Dialog } from 'components/Dialog'
import { COLOR, pxToRem } from 'theme'
import { Box } from 'components/Layout'
import Card from 'components/Card'
import Icon from 'components/Icon'

import { Text } from 'components/Typography'

interface WarningProps {
  travelStatus: ClearanceStatusType | null
  exposureStatus: ClearanceStatusType | null
}

interface Props {
  isWarningDialogOpen: WarningProps | null
  setIsWarningDialogOpen: (data: WarningProps | null) => void
}
const WARNING_TEXT = {
  travelStatus: 'User has travelled in the past 14 days.',
  exposureStatus: 'User has been exposed to someone diagnosed with COVID-19 in the past 14 days',
}

export const WarningDialog = ({ isWarningDialogOpen, setIsWarningDialogOpen }: Props) => (
  <Dialog
    variant="center"
    maxWidth={pxToRem(500)}
    isOpen={!!isWarningDialogOpen}
    onDismiss={() => setIsWarningDialogOpen(null)}
  >
    <Box flexDirection="column" width="100%">
      <Card.Title onDismiss={() => setIsWarningDialogOpen(null)}>Warning</Card.Title>
      <Card.Content>
        <Box>
          <Text>The following warnings were found:</Text>
          <Box mt="1rem">
            {isWarningDialogOpen &&
              Object.entries(isWarningDialogOpen).map(([key, value]) => {
                if (value === ClearanceStatusType.Warning)
                  return (
                    <Box>
                      <Icon.Warning size="XL" color={COLOR.warning} />{' '}
                      {WARNING_TEXT[key as keyof typeof WARNING_TEXT]}
                    </Box>
                  )
                return null
              })}
          </Box>
        </Box>
      </Card.Content>
    </Box>
  </Dialog>
)
